//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../lib/date';
import { getRoomsByMemberId, relieveMemberFamilyEntity } from '../../api/newOwner';
import OwnerWorkOrders from '../project/owner/conmponents/owner-workOrders';
import OwnerQuestionnaire from '../project/owner/conmponents/owner-questionnaire';
import fileUploader from '../../views/common-components/file-uploader';
import nations from '../../lib/nations';

export default {
    name: 'memberInfo',
    components: { OwnerQuestionnaire, OwnerWorkOrders, fileUploader },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        const vm = this;
        return {
            id: 0,
            loading: false,
            saving: false,
            list: [],
            totalCount: 0,
            pageSize: 20,
            currentPage: 1,
            columns: [
                { type: 'index', width: 60, align: 'center' },
                { title: '摘要', key: 'summary', align: 'center' },
                {
                    title: '交易积分', key: 'amount', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.entryType === 0) {
                            return h('span', '+' + row.amount);
                        } else if (row.entryType === 1) {
                            return h('span', '-' + row.amount);
                        }
                    }
                },
                { title: '剩余积分', align: 'center', key: 'accountBalance' },
                { title: '交易时间', align: 'center', key: 'tradeDateStr' }

            ],
            owners: [],
            roomColumns: [
                { type: 'index', width: 60, align: 'center' },
                { title: '城市名称', key: 'cityName', align: 'center' },
                { title: '项目名称', key: 'projectName', align: 'center' },
                { title: '分期', key: 'projectStages', align: 'center' },
                { title: '楼栋', key: 'roomStructureName', align: 'center' },
                { title: '单元', key: 'chamberName', align: 'center' },
                { title: '楼层', align: 'center', key: 'storeyName' },
                { title: '房号', align: 'center', key: 'roomNumber' },
                {
                    title: '操作', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        actions.push(h('Button', {
                            props: {
                                type: 'default',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.onUnbindOwner(params.row);
                                }
                            }
                        }, '解除绑定'));

                        return h('div', actions);
                    }
                }
            ],
            activeName: 'name1',
            editMemberModal: false,
            memberInputDto: {
                memberExtend: {},
                identityImage: {}
            },
            rules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                phoneNumber: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                cardNum: [{ required: true, message: '请输入证件号', trigger: 'blur' }]
            },
            nations,
            educationColumns: ['小学', '初中', '高中', '技工学校', '中专', '大学专科和专科学校', '大学', '研究生']
        };
    },
    methods: {
        getMemberById() {
            this.loading = true;
            this.$store.dispatch({
                type: 'member/getMemberById',
                id: this.id
            }).then(() => {
                this.getOwners();
            }).finally(() => {
                this.loading = false;
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getList();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getList();
        },
        getList() {
            let params = {
                accountCorrelationId: this.id,
                accountType: 0,
                // entryType: this.entryType < 0 ? '' : this.entryType,
                // tradeDate: new Date(),
                filter: '',
                sorting: '',
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            this.loading = true;
            abp.ajax.post('/api/services/app/PointAccount/SearchPointAccountDetails', params).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        getOwners() {
            getRoomsByMemberId(this.id).then(res => {
                this.owners = [];
                this.owners.push(...res.data.result);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        },
        onUnbindOwner(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认与该业主（房源）解除绑定',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    const page = { memberId: vm.id, roomId: row.id };
                    relieveMemberFamilyEntity(page).then(res => {
                        vm.getOwners();
                        // this.totalCount = res.data.result.totalCount;
                    }).finally(() => {
                        // this.loading = false;
                    });

                }
            });
        },
        tabChange(value) {
            this.activeName = value;
        },
        onEditMember() {
            this.memberInputDto = {};
            this.memberInputDto = JSON.parse(JSON.stringify(this.memberInfo));
            if (!this.memberInputDto.memberExtend) {
                this.memberInputDto.memberExtend = {};
            }
            this.memberInputDto.identityImage = {};
            this.editMemberModal = true;
        },
        onUpdateMember() {
            this.memberInputDto.birthday = formatDate(new Date(this.memberInputDto.birthday), 'yyyy-MM-dd');
            this.$refs.editMemberForm.validate((valid) => {
                if (valid) {
                    this.saving = true;
                    abp.ajax.put('/api/services/app/Member/UpdateMember', this.memberInputDto).then(res => {
                        this.$Notice.success({
                            title: '通知',
                            desc: '保存成功'
                        });
                        this.getMemberById();
                        this.editMemberModal = false;
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });

        }
    },
    computed: {
        memberInfo() {
            const d = this.$store.state.member.memberInfo;
            if (!d.memberExtend) {
                d.memberExtend = {};
            }
            d.nativeCodeArray = [];
            d.domicilePlaceCodeArray = [];
            if (d.nativeCode) {
                d.nativeCodeArray.push(d.nativeCode.substring(0, 2) + '0000');
                d.nativeCodeArray.push(d.nativeCode.substring(0, 4) + '00');
                d.nativeCodeArray.push(d.nativeCode);
            }
            if (d.domicilePlaceCode) {
                d.domicilePlaceCodeArray.push(d.domicilePlaceCode.substring(0, 2) + '0000');
                d.domicilePlaceCodeArray.push(d.domicilePlaceCode.substring(0, 4) + '00');
                d.domicilePlaceCodeArray.push(d.domicilePlaceCode);
            }
            return d;
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getMemberById();
            this.getList();
        }
    }
};
